import ReportServices from 'services/ReportServices';

class Tracking {
  trackEvent(event = '') {
    return;
    ReportServices.tracking({ event });
  }

  trackLocation(page = '') {
    return;
    ReportServices.tracking({ page });
  }
}

export default new Tracking();
